<template>
  <v-main></v-main>
</template>

<script>
import Main from '@/views/Main.vue'
export default {
  name: 'App',
  components: {
    'v-main': Main
  }
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
  border: 0;
}
body{
  min-width: 1000px;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
@media screen and (max-width: 800px){
  body{
    min-width: unset;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue